import axiosClient from '../utils/apiClient';
import { AxiosResponse } from 'axios';
import {
  GetExclusionsByPlayerResponse,
  ExclusionOrderResponse,
} from '@inplay/models';
import { ExclusionOrderModel } from '../models/exclusionOrderModel';

export class ExclusionService {
  public async getExclusionsByProfileId(
    profileId: string,
  ): Promise<ExclusionOrderModel[]> {
    try {
      console.log('[ExclusionService][getExclusionsByProfileId] entry', {
        profileId,
      });

      const response: AxiosResponse = await axiosClient.get(
        `/exclusions/player/${profileId}`,
      );

      const data: GetExclusionsByPlayerResponse = response?.data;
      const models: ExclusionOrderModel[] = data.exclusionOrders.map(
        (order: ExclusionOrderResponse) => new ExclusionOrderModel(order),
      );

      console.log('[ExclusionService][getExclusionsByProfileId] exit', {
        count: models.length,
      });
      return models;
    } catch (error: unknown) {
      console.error(
        '[ExclusionService][getExclusionsByProfileId] ERROR',
        error,
      );
      throw error;
    }
  }
}
